


export const Booking_START = 'Booking_START';
export const Booking_END = 'Booking_END';
export const Booking_ERROR = 'Booking_ERROR';
export const Booking_SUCCESS = 'Booking_SUCCESS';
export const Booking_FAIL = 'Booking_FAIL';
export const BookingCompany_SUCCESS = 'BookingCompany_SUCCESS';
export const BookingEventList_SUCCESS = 'BookingEventList_SUCCESS';
export const SingleEvent_SUCCESS ='SingleEvent_SUCCESS';
export const AvalaibleSlots_SUCCESS ='AvalaibleSlots_SUCCESS';

export const PaidEvent_SUCCESS ='PaidEvent_SUCCESS';
export const FreeEvent_SUCCESS ='FreeEvent_SUCCESS';


export const PaidEvent_FAIL ='PaidEvent_FAIL';
export const FreeEvent_FAIL ='FreeEvent_FAIL';

export const IsDataSubmitedSuccessfully ='IsDataSubmitedSuccessfully';